export default __webpack_public_path__ + "static/media/ContactUsPhoneNumber.800750e5.svg";